import React from 'react';
import Text from './UI/Text';
import Title from './UI/Title';
import graph from '../images/graph.png';
import Table from './UI/Table';

 const Energy = () => (
   <div>
     <Title> התייעלות אנרגטית - מייצב מתח </Title>
     <Text>
       <p className='text-2xl md:text-3xl font-secular text-center py-5'> יעילות אנרגטית בהישג ידך, </p>
       <p className='text-center'>
         היום יותר מתמיד, חשוב לחסוך בהוצאות של העסק שלך.מפעלים, מרכזים מסחריים, מלונות ובניני משרדים יכולים לחסוך עשרות אלפי שקלים בשנה, באמצעות פתרון טכנולוגי פשוט.<br />
       </p>
       <p className='text-center font-semibold my-4'>יעילות אנרגטית - מייצבי המתח של ORTEA</p>
       <p>
         המתח המסופק על ידי חברת חשמל לצרכנים הסופים נע בטווח של +-400V כאשר בפועל המתח הנצרך על ידי הצרכנים (בנייני משרדים, בתי מלון, מפעלים, קווי יצור, קניונים) נע בין 370V-380V המתח העודף הוא למעשה כסף שהצרכן "זורק"
         לפח....
       </p>
       <p>
         מתח עודף זה יוצר חום מבוזבז ובלאי למכשירים החשמליים כך שייצוב המתח מהווה חיסכון כפול לצרכן גם חיסכון בחשבון החשמל וגם אורך חיי מוצר ארוכים יותר. בנוסף ייצוב המתח שומר על הצרכן מפני נחשולי מתח והרמוניות מכיוון
         הרשת ושוב הצרכן נהנה מאורך חיי מוצר (מזגנים, צ'לרים, קווי ייצור, מנועים חשמליים, נורות חשמל) ארוכים וחסכוניים יותר.
       </p>
       <div className='grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-6 mt-12'>

         <Table className='w-20 text-center' />

         <img className='mx-auto' src={graph} alt='גרף על היתרון' />
       </div>
     </Text>
   </div>
 )
export default Energy